import Link from '@slickdeals/blueprint-twig/javascript/components/link';
import Paragraph from '@slickdeals/blueprint-twig/javascript/components/paragraph';
import { TooltipSize, TooltipPosition } from '@slickdeals/blueprint-twig/javascript/components/tooltip';
import CashbackTag from '../patterns/cashbackTag';
/** The name of the module */
export const name = 'CashbackTagInjector';
export var InjectType;
(function (InjectType) {
    InjectType["Append"] = "append";
    InjectType["Prepend"] = "prepend";
    InjectType["InsertBefore"] = "insertBefore";
})(InjectType || (InjectType = {}));
/**
 * Creates a document fragment for use as the content for the tooltip
 *
 * @param offer Offer object
 */
const getTooltipContent = (offer) => {
    // Create document fragment to append elements to
    const tooltipContent = document.createDocumentFragment();
    // Create paragraph element containing offer description text
    const paragraphElement = Paragraph.createElement(offer.description);
    tooltipContent.appendChild(paragraphElement);
    // If a URL for the ToS is supplied, add a link to it
    if (offer.tosUrl) {
        const linkElement = Link.createElement(offer.tosUrl, {
            targetNewWindow: true,
            content: 'Show Details',
        });
        tooltipContent.appendChild(linkElement);
    }
    return tooltipContent;
};
/**
 * Add Cashback Tag to element
 *
 * @param offer Loyalty offer
 * @param elm HTML element to add tag to
 * @param options Options around how tag should be added
 */
export const addTagToElement = ({ offer, elm, cashbackTagModifiers = [], injectType = InjectType.Append, tooltipModifiers = {
    size: TooltipSize.Default,
    position: TooltipPosition.TopLeft,
}, availableTypes = '', }) => {
    if (!elm) {
        return;
    }
    let tooltipContent;
    if (offer.description) {
        tooltipContent = getTooltipContent(offer);
    }
    const tag = CashbackTag.createElement(offer.offerText, {
        modifiers: cashbackTagModifiers,
        tooltip: tooltipContent,
        tooltipModifiers,
    });
    if (availableTypes) {
        tag.classList.add(`bp-p-cashbackTag--${availableTypes}`);
    }
    if (injectType === InjectType.InsertBefore) {
        elm.parentNode.insertBefore(tag, elm);
    }
    else if (injectType === InjectType.Prepend) {
        elm.prepend(tag);
    }
    else {
        elm.append(tag);
    }
};
